if (!customElements.get("price-range-slider")) {
  customElements.define(
    "price-range-slider",
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initSliders();
      }

      initSliders() {
        const rangeMin = this.querySelector(".range-min");
        const rangeMax = this.querySelector(".range-max");
        const rangeMinValue = this.querySelector(".range-min-value");
        const rangeMaxValue = this.querySelector(".range-max-value");

        rangeMin.addEventListener("change", () => {
          rangeMinValue.textContent = rangeMin.value;
          this.updateInputValue("filter.v.price.gte", rangeMin.value);
        });

        rangeMax.addEventListener("change", () => {
          rangeMaxValue.textContent = rangeMax.value;
          this.updateInputValue("filter.v.price.lte", rangeMax.value);
        });
      }

      updateInputValue(name, value) {
        const input = this.querySelector(`[name="${name}"]`);
        if (input) {
          input.value = parseInt(value, 10);
        }
      }
    }
  );
}
